"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabBody = exports.TabHeader = exports.Tab = exports.TabLayout = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var MDIcon_1 = require("../../components/MDIcon");
var Menu_1 = require("../../components/Menu");
var Row_1 = require("../../components/Row");
var css_1 = require("@emotion/css");
var useRandomGuid_1 = require("../../hooks/useRandomGuid");
var R = __importStar(require("../../utils/ramda"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var react_dom_1 = require("react-dom");
require("./TabLayout.css");
var TabLayoutContext_1 = require("./TabLayoutContext");
var errorIcon = (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
  icon: "alert-circle",
  size: "1.2em",
  color: "var(--color-icon-critical)"
});
(0, MDIcon_1.preloadIcons)("menu-down", "alert-circle");
var TabLayout = function (_a) {
  var _b;
  var _c = _a.floatingHeader,
    floatingHeader = _c === void 0 ? false : _c,
    _d = _a.headerHeight,
    headerHeight = _d === void 0 ? 0 : _d,
    _e = _a.headerWidth,
    headerWidth = _e === void 0 ? 0 : _e,
    _f = _a.lazy,
    lazy = _f === void 0 ? false : _f,
    selectedId = _a.selectedId,
    children = _a.children,
    themeColor = _a.themeColor,
    onTabClick = _a.onTabClick,
    selectTab = _a.selectTab,
    _g = _a.labelSeparator,
    labelSeparator = _g === void 0 ? true : _g,
    className = _a.className,
    _h = _a.overflowText,
    overflowText = _h === void 0 ? "More" : _h,
    restProps = __rest(_a, ["floatingHeader", "headerHeight", "headerWidth", "lazy", "selectedId", "children", "themeColor", "onTabClick", "selectTab", "labelSeparator", "className", "overflowText"]);
  var _j = __read((0, useRandomGuid_1.useRandomGuid)(), 1),
    guid = _j[0];
  var headerRef = (0, react_1.useRef)(null);
  var menuRef = (0, react_1.useRef)(null);
  var cssClass = (0, css_1.css)({
    "--accent-color": themeColor !== null && themeColor !== void 0 ? themeColor : "#49c5b1"
  });
  var cn = (0, classnames_1.default)("vsx-tab-layout", className, cssClass);
  var _k = __read((0, react_1.useState)({}), 2),
    tabLabels = _k[0],
    setTabLabels = _k[1];
  var _l = __read((0, react_1.useState)({}), 2),
    tabErrors = _l[0],
    setTabErrors = _l[1];
  var registerTabLabel = function (id, node) {
    //@ts-ignore
    setTabLabels(function (old) {
      return R.assoc(id, node, old);
    });
  };
  var registerTabError = function (id, error) {
    //@ts-ignore
    setTabErrors(function (old) {
      return R.assoc(id, error, old);
    });
  };
  var _m = __read((0, react_1.useState)(new Set()), 2),
    hiddenLabels = _m[0],
    setHiddenLabels = _m[1];
  var showTabLabel = function (tabId) {
    setHiddenLabels(function (oldSet) {
      var newSet = new Set(oldSet);
      newSet.delete(tabId);
      return newSet;
    });
  };
  var hideTabLabel = function (tabId) {
    setHiddenLabels(function (oldSet) {
      var newSet = new Set(oldSet);
      newSet.add(tabId);
      return newSet;
    });
  };
  return (0, jsx_runtime_1.jsx)("div", __assign({
    "data-guid": guid,
    className: cn
  }, restProps, {
    children: (0, jsx_runtime_1.jsxs)(TabLayoutContext_1.TabLayoutContext.Provider, __assign({
      value: {
        registerTabError: registerTabError,
        registerTabLabel: registerTabLabel,
        hiddenLabels: hiddenLabels,
        showTabLabel: showTabLabel,
        hideTabLabel: hideTabLabel,
        headerRef: headerRef,
        menuRef: menuRef,
        guid: guid,
        lazy: lazy,
        labelSeparator: labelSeparator,
        selectedId: selectedId,
        selectTab: selectTab,
        onTabClick: onTabClick,
        themeColor: themeColor
      }
    }, {
      children: [(0, jsx_runtime_1.jsx)(exports.TabHeader, {
        menuRef: menuRef,
        headerRef: headerRef,
        hiddenLabels: hiddenLabels,
        floatingHeader: floatingHeader,
        headerWidth: headerWidth,
        overflowError: hiddenLabels.has(selectedId) && tabErrors[selectedId],
        overflowText: (_b = hiddenLabels.has(selectedId) ? tabLabels[selectedId] : overflowText) !== null && _b !== void 0 ? _b : overflowText
      }), (0, jsx_runtime_1.jsx)(exports.TabBody, __assign({
        floatingHeader: floatingHeader,
        headerHeight: headerHeight
      }, {
        children: children
      }))]
    }))
  }));
};
exports.TabLayout = TabLayout;
var Tab = function (_a) {
  var label = _a.label,
    id = _a.id,
    children = _a.children,
    _b = _a.error,
    error = _b === void 0 ? false : _b,
    className = _a.className,
    disabled = _a.disabled,
    restProps = __rest(_a, ["label", "id", "children", "error", "className", "disabled"]);
  var _c = (0, react_1.useContext)(TabLayoutContext_1.TabLayoutContext),
    registerTabLabel = _c.registerTabLabel,
    registerTabError = _c.registerTabError,
    headerRef = _c.headerRef,
    selectTab = _c.selectTab,
    selectedId = _c.selectedId,
    menuRef = _c.menuRef,
    hiddenLabels = _c.hiddenLabels,
    lazy = _c.lazy,
    _d = _c.onTabClick,
    onTabClick = _d === void 0 ? R.N : _d;
  var selected = !R.isEmpty(selectedId) && id == selectedId;
  var rendered = !lazy || lazy && selected;
  var _e = __read((0, react_1.useState)(null), 2),
    labelPortal = _e[0],
    setLabelPortal = _e[1];
  var _f = __read((0, react_1.useState)(null), 2),
    menuPortal = _f[0],
    setMenuPortal = _f[1];
  (0, react_1.useEffect)(function () {
    registerTabLabel(id, label);
  }, [label, id]);
  (0, react_1.useEffect)(function () {
    registerTabError(id, error);
  }, [error, id]);
  (0, react_1.useLayoutEffect)(function () {
    var labelElm = (0, jsx_runtime_1.jsx)(TabLabel, __assign({
      onTabClick: onTabClick,
      onSelectClick: selectTab,
      tabId: id,
      error: error,
      disabled: disabled,
      selected: selected
    }, {
      children: label
    }));
    var _labelPortal = headerRef.current ? (0, react_dom_1.createPortal)(labelElm, headerRef.current) : null;
    setLabelPortal(_labelPortal);
    var menuElm = (0, jsx_runtime_1.jsx)(Menu_1.MenuOption, __assign({
      tooltipProps: {
        wrapperProps: {
          hidden: !hiddenLabels.has(id)
        }
      },
      "data-tab-id": id,
      "data-error": error,
      "data-selected": selected,
      selected: selected,
      disabled: disabled,
      onClick: function (e) {
        selectTab(e, id);
        onTabClick();
      }
    }, {
      children: (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
        align: "center",
        gap: "medium-small"
      }, {
        children: [error && errorIcon, (0, jsx_runtime_1.jsx)("span", {
          children: label
        })]
      }))
    }));
    var _menuPortal = menuRef.current ? (0, react_dom_1.createPortal)(menuElm, menuRef.current) : null;
    setMenuPortal(_menuPortal);
  }, [selectTab, id, error, disabled, headerRef.current, menuRef.current, label, hiddenLabels]);
  var tabContent = rendered ? (0, jsx_runtime_1.jsx)("div", __assign({
    className: (0, classnames_1.default)("vsx-tab-content standard", className),
    hidden: !selected
  }, restProps, {
    children: children
  })) : null;
  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [labelPortal, menuPortal, tabContent]
  });
};
exports.Tab = Tab;
var TabLabel = function (_a) {
  var _b = _a.disabled,
    disabled = _b === void 0 ? false : _b,
    tabId = _a.tabId,
    children = _a.children,
    _c = _a.onTabClick,
    onTabClick = _c === void 0 ? R.N : _c,
    onSelectClick = _a.onSelectClick,
    error = _a.error,
    themeColor = _a.themeColor,
    _d = _a.separator,
    separator = _d === void 0 ? true : _d,
    restProps = __rest(_a, ["disabled", "tabId", "children", "onTabClick", "onSelectClick", "error", "themeColor", "separator"]);
  var _e = (0, react_1.useContext)(TabLayoutContext_1.TabLayoutContext),
    selectedId = _e.selectedId,
    showTabLabel = _e.showTabLabel,
    hideTabLabel = _e.hideTabLabel,
    hiddenLabels = _e.hiddenLabels;
  var ref = (0, react_1.useRef)(null);
  var _f = __read((0, react_1.useState)(false), 2),
    hover = _f[0],
    setHover = _f[1];
  var onMouseOver = function () {
    setHover(true);
  };
  var onMouseLeave = function () {
    setHover(false);
  };
  var hidden = hiddenLabels.has(tabId);
  var selected = !R.isNothing(selectedId) && tabId == selectedId;
  var labelStateClassName = (0, react_1.useMemo)(R.cond([[R.always(disabled), R.always("vsx-tab-label-disabled")], [R.always(selected), R.always("vsx-tab-label-clicked")], [R.T, function () {
    return null;
  }]]), [disabled, selected]);
  var labelClassName = (0, classnames_1.default)("vsx-tab-label", !separator && "vsx-tab-label-no-border", labelStateClassName, hidden && "vsx-tab-label-hidden");
  var hoverStyle = (0, react_1.useMemo)(R.cond([[R.always(disabled || selected), function () {
    return {};
  }], [R.always(hover), function () {
    return {
      color: "var(--accent-color)",
      cursor: "pointer"
    };
  }], [R.T, function () {
    return {
      color: "#888"
    };
  }]]), [disabled, selected, hover]);
  var labelStyle = selected ? {
    borderBottom: "4px solid var(--accent-color)"
  } : {};
  (0, react_1.useLayoutEffect)(function () {
    if (!ref.current) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var id = entry.target.getAttribute("data-tab-id");
        entry.isIntersecting ? showTabLabel(id) : hideTabLabel(id);
      });
    }, {
      root: ref.current.parentElement,
      threshold: 1
    });
    observer.observe(ref.current);
    return function () {
      return observer.disconnect();
    };
  }, [ref.current]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    ref: ref,
    className: labelClassName,
    onClick: function (event) {
      if (!disabled) {
        onSelectClick(event, tabId);
        onTabClick();
      }
    },
    onMouseOver: onMouseOver,
    onMouseLeave: onMouseLeave,
    style: hoverStyle,
    "data-tab-id": tabId
  }, {
    children: (0, jsx_runtime_1.jsx)("div", __assign({
      className: (0, classnames_1.default)("vsx-tab-label-child", error && "vsx-tab-label-error"),
      role: "tab",
      style: labelStyle
    }, {
      children: (0, jsx_runtime_1.jsx)(TabLabelContent, {
        children: (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
          align: "center",
          gap: "medium-small"
        }, {
          children: [error && errorIcon, (0, jsx_runtime_1.jsx)("span", {
            children: children
          })]
        }))
      })
    }))
  }));
};
var TabLabelContent = function (_a) {
  var children = _a.children,
    restProps = __rest(_a, ["children"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: "vsx-tab-label-content standard"
  }, {
    children: children
  }));
};
var TabHeader = function (_a) {
  var floatingHeader = _a.floatingHeader,
    headerWidth = _a.headerWidth,
    headerRef = _a.headerRef,
    hiddenLabels = _a.hiddenLabels,
    menuRef = _a.menuRef,
    _b = _a.overflowText,
    overflowText = _b === void 0 ? "More" : _b,
    overflowError = _a.overflowError,
    restProps = __rest(_a, ["floatingHeader", "headerWidth", "headerRef", "hiddenLabels", "menuRef", "overflowText", "overflowError"]);
  var cn = (0, classnames_1.default)("vsx-tab-header", floatingHeader && "vsx-tab-header-floating");
  var headerCss = floatingHeader ? {
    width: "".concat(headerWidth)
  } : {};
  var selectedId = (0, react_1.useContext)(TabLayoutContext_1.TabLayoutContext).selectedId;
  var ref = (0, react_1.useRef)(null);
  return (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    refObject: ref,
    gap: "small",
    className: "vsx-tab-header-container",
    align: "start"
  }, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      ref: headerRef
    }, restProps, {
      className: cn,
      role: "tablist",
      style: headerCss
    })), (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "vsx-tab-header-collapsed",
      "data-selected": hiddenLabels.has(selectedId),
      hidden: hiddenLabels.size === 0
    }, {
      children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
        align: "center",
        gap: "medium-small"
      }, {
        children: [overflowError && errorIcon, (0, jsx_runtime_1.jsx)("span", __assign({
          className: "vsx-tab-header-overflow-text"
        }, {
          children: overflowText
        }))]
      })), (0, jsx_runtime_1.jsx)(Menu_1.Menu, {
        refObject: menuRef
      })]
    }))]
  }));
};
exports.TabHeader = TabHeader;
var TabBody = function (_a) {
  var children = _a.children,
    floatingHeader = _a.floatingHeader,
    headerHeight = _a.headerHeight,
    restProps = __rest(_a, ["children", "floatingHeader", "headerHeight"]);
  var headerHeightCss = floatingHeader ? {
    paddingTop: "".concat(headerHeight)
  } : {};
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: "vsx-tab-body",
    role: "tabpanel",
    style: headerHeightCss
  }, {
    children: children
  }));
};
exports.TabBody = TabBody;
// prevents tests from breaking
window.IntersectionObserver = (_a = window.IntersectionObserver) !== null && _a !== void 0 ? _a : function () {
  return {
    observe: function () {
      return null;
    },
    unobserve: function () {
      return null;
    },
    disconnect: function () {
      return null;
    }
  };
};